import { Syringe } from '../core';
export var Provider = Syringe.defineToken('ContributionProvider');